import h from "trader-hyperscript";
import { Source } from "trader.ts/types/source";
import * as routes from "../../routes";
import * as style from "../../../styles/style.css.classes";
import { textbox } from "trader.ts/ui.common";
import { emailid } from "../../../sql/classy/types";
import { rpc } from "trader.ts/network";

export function render(opts: {
  address: string;
  emailid: emailid;
}): HTMLElement | HTMLElement[] {
  const s = new Source(opts.address);
  async function remove() {
    await rpc(routes.removeEmailSpec, undefined, { emailid: opts.emailid });
    document.location = routes.erroremailsRoute.link();
  }
  async function resend() {
    await rpc(routes.resendEmailSpec, undefined, {
      emailid: opts.emailid,
      newAddress: s.get(),
    });
    document.location = routes.erroremailsRoute.link();
  }
  return (
    <div>
      <article>{textbox({ source: s, label: "Nieuw adres" })}</article>
      <div className={style.equal_columns_non_responsive}>
        <button onclick={remove}>{"Verwijder verzending"}</button>
        <button onclick={resend}>{"Stuur naar adres"}</button>
      </div>
    </div>
  );
}
